module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_tasteshop_m.c358c12b9c752594b1f140709b486ed5.png";